class BnthAnnouncements extends HTMLElement {
  connectedCallback() {
    this.layout = this.dataset.layout;
    this.speed = parseInt(this.dataset.speed, 10) || 5000;
    this.moneyFormat = this.dataset.moneyFormat || "${{amount}}";
    this.paused = false;

    if (this.layout === "slider") {
      this.initSlider();
    } else if (this.layout === "marquee") {
      this.initMarquee();
    }

    this.initFreeShipping();
  }

  disconnectedCallback() {
    clearInterval(this.sliderInterval);
    document.removeEventListener("theme:cart:change", this._onCartChange);
  }

  // ── Slider ──────────────────────────────────────────────────────────────────

  initSlider() {
    this.slides = Array.from(this.querySelectorAll(".bn3th-announcements__slide"));
    this.pauseBtn = this.querySelector("[data-pause-btn]");

    if (this.slides.length <= 1) return;

    this.currentIndex = 0;
    this.sliderInterval = setInterval(() => this.advance(), this.speed);

    if (this.pauseBtn) {
      this.pauseBtn.addEventListener("click", () => this.togglePause());
    }
  }

  advance() {
    if (this.paused) return;

    const current = this.slides[this.currentIndex];
    current.classList.remove("is-active");
    current.setAttribute("aria-hidden", "true");

    let next = (this.currentIndex + 1) % this.slides.length;
    let attempts = 0;

    while (attempts < this.slides.length) {
      const device = this.slides[next].dataset.device;
      const isMobile = window.matchMedia("(max-width: 767px)").matches;
      if (
        device === "all" ||
        (device === "mobile" && isMobile) ||
        (device === "desktop" && !isMobile)
      ) break;
      next = (next + 1) % this.slides.length;
      attempts++;
    }

    this.currentIndex = next;
    const nextSlide = this.slides[this.currentIndex];
    nextSlide.classList.add("is-active");
    nextSlide.setAttribute("aria-hidden", "false");
  }

  togglePause() {
    this.paused = !this.paused;
    if (this.pauseBtn) {
      this.pauseBtn.setAttribute("aria-pressed", String(this.paused));
      this.pauseBtn.setAttribute(
        "aria-label",
        this.paused ? "Play announcements" : "Pause announcements"
      );
    }
  }

  // ── Marquee ─────────────────────────────────────────────────────────────────

  initMarquee() {
    const track = this.querySelector("[data-marquee-track]");
    if (!track) return;

    const items = Array.from(track.children);
    items.forEach(item => {
      const clone = item.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      track.appendChild(clone);
    });
  }

  // ── Free shipping ────────────────────────────────────────────────────────────

  initFreeShipping() {
    const messages = this.querySelectorAll("[data-free-shipping]");
    if (!messages.length) return;

    this._onCartChange = (e) => {
      const cart = e.detail?.cart;
      if (!cart) return;
      messages.forEach(el => this.updateMessage(el, cart.total_price));
    };

    document.addEventListener("theme:cart:change", this._onCartChange);
  }

  updateMessage(el, totalPriceCents) {
    const limitCents = parseInt(el.dataset.limit, 10);
    if (!limitCents) return;

    const leftCents = Math.max(0, limitCents - totalPriceCents);
    const percent = Math.min(100, Math.round((totalPriceCents / limitCents) * 100));

    const textEl = el.querySelector("[data-message-text]");
    const progressEl = el.querySelector("[data-progress]");

    if (textEl) {
      if (percent >= 100 && el.dataset.successMessage) {
        textEl.textContent = el.dataset.successMessage;
      } else {
        const template = el.dataset.messageTemplate || "";
        textEl.innerHTML = template.replace("||amount||", this.formatMoney(leftCents));
      }
    }

    if (progressEl) {
      progressEl.style.setProperty("--progress", percent);
    }
  }

  formatMoney(cents) {
    const dollars = Math.round(cents / 100);
    return this.moneyFormat.replace(/\{\{[^}]+\}\}/, dollars);
  }
}

customElements.define("bn3th-announcements", BnthAnnouncements);
